import React from 'react';

import {
  BaseText,
  ExtraSmallText,
  MediumText,
} from '@components/shared/common';
import { LocationAddressProps } from '@models/common/location-address';
import {
  getFormattedCityStateZip,
  getFormattedLocationAddress,
} from '@utils/common';

const LocationAddress: React.FunctionComponent<LocationAddressProps> = ({
  location,
  hasUnderline,
  smallText,
  mediumText,
  OneLineMediumText,
  breakTwoLine,
  centerText,
}) => {
  const isBaseText = !smallText && !mediumText && !OneLineMediumText;

  const getExtraSmallText = () => (
    <>
      <ExtraSmallText
        pt="3px"
        pr="3px"
        underline={hasUnderline}
        data-testid="location-address1-address2"
      >
        {getFormattedLocationAddress(location)}
      </ExtraSmallText>
      <ExtraSmallText
        pt="3px"
        underline={hasUnderline}
        data-testid="location-city-state"
      >
        {getFormattedCityStateZip(location)}
      </ExtraSmallText>
    </>
  );

  const getMediumText = () => (
    <>
      <MediumText
        fWeight="400"
        pr="3px"
        underline={hasUnderline}
        data-testid="location-address1-address2"
      >
        {getFormattedLocationAddress(location)}
      </MediumText>
      <MediumText
        fWeight="400"
        underline={hasUnderline}
        data-testid="location-city-state"
      >
        {getFormattedCityStateZip(location)}
      </MediumText>
    </>
  );

  const getBaseText = () => (
    <>
      <BaseText
        fWeight="300"
        pr="3px"
        underline={hasUnderline}
        data-testid="location-address1-address2"
      >
        {getFormattedLocationAddress(location)}
      </BaseText>
      <BaseText
        fWeight="300"
        underline={hasUnderline}
        data-testid="location-city-state"
      >
        {getFormattedCityStateZip(location)}
      </BaseText>
    </>
  );

  const getOneLineMediumText = () => (
    <>
      <MediumText
        fWeight="400"
        pr="3px"
        underline={hasUnderline}
        data-testid="location-address1-address2"
      >
        {getFormattedLocationAddress(location)}{' '}
        {getFormattedCityStateZip(location)}
      </MediumText>
    </>
  );

  return (
    <div
      css={{
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: breakTwoLine ? 'column' : 'row',
        justifyContent: centerText ? 'center' : 'flex-start',
      }}
    >
      {smallText && getExtraSmallText()}
      {mediumText && getMediumText()}
      {OneLineMediumText && getOneLineMediumText()}
      {isBaseText && getBaseText()}
    </div>
  );
};

LocationAddress.defaultProps = {
  hasUnderline: false,
  smallText: false,
  breakTwoLine: false,
  centerText: false,
};

export default LocationAddress;
